import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import qs from 'qs';
import { api } from '.';
import { getOrganizationCompanyPlatformMap } from '../constants/organizationCompany';
import { handleRequestError } from '../utils/request';
import { handleOrganizationCompanyRegions } from './utils/organizationCompany'; // Query organization company

export var apiQueryOrganizationCompanyList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var _res$data, params, res;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            params = _objectSpread({}, payload);
            delete params.organization_id;
            _context.next = 5;
            return api.get("/companies/organization/".concat(payload.organization_id, "?").concat(qs.stringify(params)));

          case 5:
            res = _context.sent;
            if (!res.data) res.data = {};
            res.data.companies = (((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.companies) || []).map(function (item) {
              var _getOrganizationCompa, _tempItem$meta;

              var tempItem = _objectSpread(_objectSpread({}, item === null || item === void 0 ? void 0 : item.company), item);

              tempItem.value = tempItem.id;
              tempItem.label = tempItem.name;
              tempItem.platformText = ((_getOrganizationCompa = getOrganizationCompanyPlatformMap()[tempItem === null || tempItem === void 0 ? void 0 : (_tempItem$meta = tempItem.meta) === null || _tempItem$meta === void 0 ? void 0 : _tempItem$meta.platform_source]) === null || _getOrganizationCompa === void 0 ? void 0 : _getOrganizationCompa.label) || '';
              tempItem.regions = handleOrganizationCompanyRegions(tempItem.regions); // Can be deleted later
              // let allCountryText = '';
              // const haveGlobal = tempItem.regions.some(
              //   (cItem) => cItem.setGlobalCountry
              // );
              // const haveRestOfRegions = tempItem.regions.some(
              //   (cItem) => cItem.restOfWorld
              // );
              // // All countries
              // const allCountry = [];
              // // Countries other than the rest of the world
              // const restShowCountry = [];
              // tempItem.regions.forEach((cItem) => {
              //   allCountry.push(...(cItem.countries || []));
              //   if (!cItem.restOfWorld) {
              //     restShowCountry.push(...(cItem.countries || []));
              //   }
              // });
              // if (haveGlobal) {
              //   allCountryText = 'Global';
              // } else {
              //   const countryCodeList = restShowCountry.map((aItem) => aItem.code);
              //   if (haveRestOfRegions) {
              //     countryCodeList.push('Rest of world');
              //   }
              //   if (countryCodeList.length > 0) {
              //     allCountryText = countryCodeList.join(',');
              //   }
              // }
              // tempItem.countryCount = allCountry.length;
              // tempItem.allCountryText = allCountryText;

              tempItem.allCountryText = '';
              return tempItem;
            });
            return _context.abrupt("return", [res.data]);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", handleRequestError(_context.t0, payload));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));

  return function apiQueryOrganizationCompanyList(_x) {
    return _ref.apply(this, arguments);
  };
}();